import * as actions from "@rpforms/shared/build/actions/customFields";
import { getCustomFields } from "@rpforms/shared/build/actions";
import { Button } from "@rpforms/shared/build/components/Button";
import { SmallButton } from "@rpforms/shared/build/components/layout/Button";
import { Scrollable } from "@rpforms/shared/build/components/layout/Popover";
import { FooterField } from "@rpforms/shared/build/fields/FooterField";
import { HeaderField } from "@rpforms/shared/build/fields/HeaderField";
import { RepeaterField } from "@rpforms/shared/build/fields/RepeaterField";
import { CheckboxField } from "@rpforms/shared/build/fields/CheckboxField";
import { ColumnField } from "@rpforms/shared/build/fields/ColumnField";
import { ConfigField } from "@rpforms/shared/build/fields/ConfigField";
import { DateField } from "@rpforms/shared/build/fields/DateField";
import { EmailField } from "@rpforms/shared/build/fields/EmailField";
import { GroupField } from "@rpforms/shared/build/fields/GroupField";
import { HSpacerField } from "@rpforms/shared/build/fields/HSpacerField";
import { ImageField } from "@rpforms/shared/build/fields/ImageField";
import { IntegerField } from "@rpforms/shared/build/fields/IntegerField";
import { InvoicePositionsListField } from "@rpforms/shared/build/fields/InvoicePositionsListField";
import { LocationField } from "@rpforms/shared/build/fields/LocationField";
import { PageBreakField } from "@rpforms/shared/build/fields/PageBreakField";
import { ParagraphField } from "@rpforms/shared/build/fields/ParagraphField";
import { PasswordField } from "@rpforms/shared/build/fields/PasswordField";
import { PhonenumberField } from "@rpforms/shared/build/fields/PhonenumberField";
import { PictureField } from "@rpforms/shared/build/fields/PictureField";
import { RadioField } from "@rpforms/shared/build/fields/RadioField";
import { RescheduleField } from "@rpforms/shared/build/fields/RescheduleField";
import { RowField } from "@rpforms/shared/build/fields/RowField";
import { ScriptField } from "@rpforms/shared/build/fields/ScriptField";
import { SeparatorField } from "@rpforms/shared/build/fields/SeparatorField";
import { SignatureField } from "@rpforms/shared/build/fields/SignatureField";
import { SpacerField } from "@rpforms/shared/build/fields/SpacerField";
import { StyleField } from "@rpforms/shared/build/fields/StyleField";
import { TableField } from "@rpforms/shared/build/fields/TableField";
import { TextareaField } from "@rpforms/shared/build/fields/TextareaField";
import { TextField } from "@rpforms/shared/build/fields/TextField";
import { TitleField } from "@rpforms/shared/build/fields/TitleField";
import { InventoryItemSelectField } from "@rpforms/shared/build/fields/InventoryItemSelectField";
import { LegendeField } from "@rpforms/shared/build/fields/LegendeField";
import React, { useState, useEffect } from "react";
import { PopoverContent, PopoverTitle } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import Popover, { ArrowContainer } from "react-tiny-popover";
import styled from "styled-components";

export const WidgetCard = styled.div`
    width: 80px;
    height: 80px;
    min-width: 80px;
    min-height: 80px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    margin: 8px;
    float: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #f0f0f0;
    background: #fff;
    color: #007bff;
    :hover {
        background: #007bff;
        color: #fff;
        cursor: pointer;
    }
    padding: 5px;
`;

export const WidgetName = styled.div`
    font-size: 12px;
    text-align: center;
`;

export const WidgetIcon = styled.div`
    font-size: 24px;
`;

export const widgets = [
    TitleField,
    SpacerField,
    HSpacerField,
    ParagraphField,
    SeparatorField,
    TextField,
    TextareaField,
    ImageField,
    DateField,
    CheckboxField,
    EmailField,
    TableField,
    LocationField,
    RadioField,
    PasswordField,
    PictureField,
    PhonenumberField,
    SignatureField,
    IntegerField,
    GroupField,
    RowField,
    ColumnField,
    RepeaterField,
    PageBreakField,
    ConfigField,
    ScriptField,
    StyleField,
    HeaderField,
    FooterField,
    RescheduleField,
    InvoicePositionsListField,
    InventoryItemSelectField,
    LegendeField,
];

/**
 * Add new fields to your form
 * @param showCustomFields
 * @param getWidgets
 * @param customWidgets
 * @param handleNewField
 * @param attached
 * @param small
 * @param fields
 * @param after
 * @constructor
 */
const AddField = ({
    showCustomFields = false,
    customFields = { customFields: [], loaded: false },
    handleNewField,
    attached = false,
    small = false,
    fields = [],
    after = null,
}: any) => {
    const [popover, setPopover] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        if (showCustomFields) {
            if (!customFields.loaded) {
                dispatch(getCustomFields());
            }
        }
    }, [showCustomFields]);

    if (fields.length === 0) {
        fields = widgets;
    }

    const label = after ? "Feld hier einfügen" : "Feld hinzufügen";

    const ButtonSize = small ? SmallButton : Button;
    const buttonStyle = attached
        ? {
            marginTop: "-2px",
            borderRadius: "0",
            marginLeft: "20px",
            marginBottom: "20px",
        }
        : {};

    return (
        <>
            <div>
                <Popover
                    isOpen={popover}
                    position={"right"} // preferred position
                    content={({ position = "top", targetRect, popoverRect }) => (
                        <ArrowContainer
                            position={position}
                            targetRect={targetRect}
                            popoverRect={popoverRect}
                            arrowColor={"white"}
                            arrowSize={10}
                            arrowStyle={{ opacity: 0.7 }}
                        >
                            <PopoverContent>
                                <PopoverTitle>Feldauswahl</PopoverTitle>
                                <Scrollable>
                                    {showCustomFields ? (
                                        <div>
                                            <strong>Eigene Felder</strong>
                                            <div className="d-flex flex-wrap">
                                                {customFields.customFields.length === 0 ? (
                                                    <div>
                                                        Noch kein eigenes Feld erstellt. Sie können
                                                        bestehende Felder über die Speichern (
                                                        <i className="fa fa-puzzle-piece" />)
                                                        Schaltfläche hier wiederverwenden
                                                    </div>
                                                ) : (
                                                    customFields.customFields.map((customField) => {
                                                        return (
                                                            <WidgetCard
                                                                key={`cf_${customField.id}`}
                                                                onClick={() => {
                                                                    setPopover(false);
                                                                    handleNewField(customField);
                                                                }}
                                                            >
                                                                <WidgetIcon>
                                                                    <i
                                                                        className={`fa fa-${customField.icon}`}
                                                                    />
                                                                </WidgetIcon>
                                                                <WidgetName>
                                                                    {customField.name}
                                                                </WidgetName>
                                                            </WidgetCard>
                                                        );
                                                    })
                                                )}
                                            </div>
                                            <hr />
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                    <div>
                                        {fields.map((field) => (
                                            <WidgetCard
                                                key={field}
                                                onClick={() => {
                                                    setPopover(false);
                                                    handleNewField(field);
                                                }}
                                            >
                                                <WidgetIcon>
                                                    <i className={`fa fa-${field.icon()}`} />
                                                </WidgetIcon>
                                                <WidgetName>{field.fieldType()}</WidgetName>
                                            </WidgetCard>
                                        ))}
                                    </div>
                                </Scrollable>
                            </PopoverContent>
                        </ArrowContainer>
                    )}
                >
                    <ButtonSize
                        style={buttonStyle}
                        type="button"
                        onClick={() => setPopover(!popover)}
                    >
                        <i className="fa fa-plus" /> {label}
                    </ButtonSize>
                </Popover>
            </div>
        </>
    );
};

function mapStateToProps(state) {
    return { customFields: state.customFields };
}

export default withRouter(connect(mapStateToProps, actions)(AddField)) as any;
